import { useEffect, useState } from "react";
import { Header2, Header4 } from "../../../../components/ui";
import { Card, CardBody, CardHeader } from "../../../../components/ui/cards";
import localization from "../../../../config/localization";
import { VerificationMethood } from "./VerificationMethood";
import { VerificationType } from "../../../../models/constants/verificationType";
import { EmailVerification } from "./EmailVerification";
import { MobileVerification } from "./MobileVerification";
import { EmailAndMobileVerfification } from "./EmailAndMobileVerfification";
import { useNavigate } from "react-router-dom";
import { ConfirmationModal } from "../../../../components/ui/modals";
import { localStorageService } from "../../../../services";
import userService from "../../services/user.service";
import { useSelector } from "react-redux";
import { selectUserProfile } from "../../selectors/userProfileSelectors";
import { RegistrationType } from "../../../../models/constants/registrationType";
import { changeLoaderState, changeLoginModalState } from "../../../../reducers/appStateReducer";
import { useAppDispatch } from "../../../../store/hooks";

export function UserVerification() {

  const [verificationMethod, setVerificationMethod] = useState<string>();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const navigate = useNavigate();
  let profile = useSelector(selectUserProfile);
  const dispatch = useAppDispatch();

  useEffect(() => {

    const shouldRender = () => {
      if (profile) {
        if (
          ((profile.registrationType === RegistrationType.ManualOrWhatsApp && profile.isOneTimePasswordChanged) ||
            profile.registrationType !== "") &&
          !profile.isSecondLoginDone &&
          profile.isSecondLoginAttempt &&
          (!profile.emailVerified || !profile.mobileVerified)
        )
          return true;
        else
          return false;
      }
    }
    if (profile) {
      if (shouldRender()) {
        navigate("/");
      }
    }
  }, [profile, navigate]);


  const handleVerificationMethodChange = (method: string) => {
    setVerificationMethod(method);
  };

  let content = null;

  const handleBackButton = () => {
    if (verificationMethod) {
      setVerificationMethod(undefined);
    }
    else {
      setShowConfirmationModal(true);
    }
  };

  const userId = localStorageService.getItem<string>("userId")!;


  const handleConfirmation = () => {
    setShowConfirmationModal(false);
    userService.updateUserSecondLoginData(userId).then((response) => {
      if (response.isSuccess) {
        dispatch(changeLoaderState(false));
        dispatch(changeLoginModalState(true));
        navigate("/");
      }
    });
  }

  switch (verificationMethod) {
    case VerificationType.Email:
      content = <EmailVerification userId={userId} handleBackButton={handleBackButton} />;
      break;
    case VerificationType.Mobile:
      content = <MobileVerification userId={userId} handleBackButton={handleBackButton} />;
      break;
    case VerificationType.Both:
      content = <EmailAndMobileVerfification userId={userId} handleBackButton={handleBackButton} />;
      break;
    default:
      content = <VerificationMethood handleVerificationMethodChange={handleVerificationMethodChange} />;
      break;
  }

  return (
    <Card>
      <CardHeader showBackButton={true} showLogo={true} onBackButtonClick={handleBackButton} />
      <CardBody showGradient={true} >
        <div className="w-full max-w-4xl mx-auto">
          <div>
            <Header2 className="text-white mb-6">{localization.details_verification}</Header2>
          </div>
          <div>
            <p>{localization.receive_cash_or_bonuses}</p>
          </div>
          <div className="mt-2">
            <Header4>{localization.verify_details}</Header4>
          </div>
          <div className="mt-4">
            {content}
          </div>
        </div>
      </CardBody>

      <ConfirmationModal
        isOpen={showConfirmationModal}
        title={localization.confirmation_Message_For_Skip_Verification}
        icon={"/icons/ic-info.svg"}
        blurColor="bg-[#FFE6CC]"
        confirmText={localization.okay}
        onConfirm={handleConfirmation}
        cancelText=""
        onCancel={() => { setShowConfirmationModal(false); }}
      ></ConfirmationModal>
    </Card >
  );
}